import { render, staticRenderFns } from "./appManageDataInterface.vue?vue&type=template&id=77e604ca"
import script from "./appManageDataInterface.vue?vue&type=script&lang=js"
export * from "./appManageDataInterface.vue?vue&type=script&lang=js"
import style0 from "./appManageDataInterface.vue?vue&type=style&index=0&id=77e604ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports